const parseXML = (xmlText) => {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlText, "text/xml");
    const productNodes = xmlDoc.getElementsByTagName("product");
    const products = [];

    for (let i = 0; i < productNodes.length; i++) {
        const node = productNodes[i];

        const getVal = (tag) => node.getElementsByTagName(tag)[0]?.textContent || "";

        const prices = [];
        const pricesNode = node.getElementsByTagName("prices")[0];
        if (pricesNode) {
            const priceNodes = pricesNode.getElementsByTagName("price");
            for (let j = 0; j < priceNodes.length; j++) {
                const weight = priceNodes[j].getAttribute("weight") || "";
                const val = parseFloat(priceNodes[j].textContent);
                if (weight && !isNaN(val)) {
                    prices.push({ weight, price: val });
                }
            }
        }

        products.push({
            id: parseInt(getVal("id")),
            name: getVal("name"),
            price: parseFloat(getVal("price")),
            category: getVal("category"),
            parentCategory: getVal("parentCategory"),
            location: getVal("location"),
            image: getVal("image"),
            rating: parseFloat(getVal("rating")) || 0,
            description: getVal("description"),
            prices
        });
    }
    return products;
};

export const getPriceForWeight = (product, weight) => {
    if (product.prices && product.prices.length > 0) {
        const match = product.prices.find(p => p.weight === weight);
        if (match) return match.price;
    }
    return product.price;
};

let cachedProducts = null;

export const GetAllProduct = async () => {
    try {
        if (cachedProducts) return cachedProducts;
        
        const response = await fetch('/producds.xml');
        const xmlText = await response.text();
        cachedProducts = parseXML(xmlText);
        return cachedProducts;
    } catch (error) {
        console.error("Error fetching or parsing XML:", error);
        return [];
    }
};

// Convert a product name to a URL-friendly slug
export const slugify = (name) => {
    return name
        .toLowerCase()
        .replace(/&amp;/g, 'and')
        .replace(/&/g, 'and')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');
};

export const GetProductBySlug = async (slug) => {
    try {
        const products = await GetAllProduct();
        return products.find(p => slugify(p.name) === slug) || null;
    } catch (error) {
        console.error("Error finding product by slug:", error);
        return null;
    }
};

export const GetByCategory = async (category, location) => {
    try {
        const products = await GetAllProduct();
        let filtered = products;

        if (category && category.toLowerCase() !== 'shop' && category.toLowerCase() !== 'all cakes' && category.toLowerCase() !== 'cakes') {
            filtered = filtered.filter(p =>
                p.category?.toLowerCase().includes(category.toLowerCase()) ||
                (p.parentCategory && p.parentCategory.toLowerCase() === category.toLowerCase())
            );
        }

        // Location filtering removed as requested to show all products on location pages
        /*
        if (location) {
            filtered = filtered.filter(p => !p.location || p.location.toLowerCase() === location.toLowerCase());
        }
        */

        return filtered;
    } catch (error) {
        console.error("Error filtering products:", error);
        return [];
    }
};

export const GetRandomProducts = async (count = 6) => {
    try {
        const products = await GetAllProduct();
        // Simple shuffle
        const shuffled = [...products].sort(() => 0.5 - Math.random());
        return shuffled.slice(0, count);
    } catch (error) {
        console.error("Error getting random products:", error);
        return [];
    }
};
